export const getAllPromoGroups = () => ({
  url: `me/promotion_groups`,
})
